"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getSearchTextFor = exports.PINSelectInput = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var PINOption_1 = require("../PINOption");
var react_2 = require("@iconify/react");
var PINInput_1 = require("../PINInput");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
function _getSearchTextFor(node) {
    if (node && node.props && node.props.children) {
        return _getSearchTextFor(node.props.children);
    }
    else if (Array.isArray(node)) {
        return node.map(_getSearchTextFor).join(" ");
    }
    else if (typeof node === "string") {
        return node;
    }
    return "";
}
exports._getSearchTextFor = _getSearchTextFor;
var PINSelectInput = /** @class */ (function (_super) {
    __extends(PINSelectInput, _super);
    function PINSelectInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpand: false,
            selectedIndex: null,
            value: _this.props.value || _this.props.defaultValue || null,
            searchText: "",
            options: PINOption_1.retrieveOptions(_this.props.children, _this.props.options),
            displayedOptions: null,
            error: null
        };
        _this.resetValue = function (newValue, options) {
            if (options === void 0) { options = _this.state.options; }
            var index = options.findIndex(function (opt) { return (opt.value === newValue); });
            if (index < 0) {
                return;
            }
            _this.setState({
                value: options[index].value,
                selectedIndex: index
            });
        };
        _this.resetOptions = function (props) {
            var options = PINOption_1.retrieveOptions(props.children, props.options);
            _this.setState(function () { return ({ searchText: "", options: options, displayedOptions: null }); });
            return options;
        };
        _this.onClickOnCurrent = function (event) {
            if (_this.props.isSearchable && _this.state.isExpand) {
                // Must stopPropagation of the nativeEvent to prevent #handleDocumentClick to capture event
                return event.nativeEvent.stopImmediatePropagation();
            }
            _this.toggleVisibility();
            event.stopPropagation();
        };
        _this.toggleVisibility = function (isExpand) {
            var newExpansionState = typeof isExpand === "boolean" ? isExpand : !_this.state.isExpand;
            if (newExpansionState) {
                // @ts-expect-error FIXME Type mismatch
                document.addEventListener("click", _this.handleDocumentClick, false);
            }
            else {
                // @ts-expect-error FIXME Type mismatch
                document.removeEventListener("click", _this.handleDocumentClick, false);
                if (typeof _this.state.value !== "string"
                    || _this.state.searchText !== _this.state.value) {
                    _this.resetOptions(_this.props);
                }
            }
            _this.setState({ isExpand: newExpansionState });
        };
        _this.isEmpty = function (selection) { return selection === null; };
        _this.handleDocumentClick = function (event) {
            if (!_this.node || _this.node.contains(event.target)) {
                return;
            }
            _this.toggleVisibility(false);
        };
        _this.onSearch = function (event) {
            var value = event.target.value || "";
            var displayedOptions = PINOption_1.retrieveOptions(_this.props.children, _this.props.options)
                .filter(function (option) {
                var searchText = _getSearchTextFor(option.label);
                return searchText.toLowerCase().includes(value.toLowerCase());
            });
            _this.setState({ searchText: value, displayedOptions: displayedOptions });
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
        _this.getValueOnChange = function (_, complement) {
            var options = PINOption_1.retrieveOptions(_this.props.children, _this.props.options);
            var selectedIndex = options.findIndex(function (option) { return (option.value === complement.option.value); });
            if (selectedIndex === _this.state.selectedIndex || selectedIndex === -1) {
                if (!_this.props.emptySelection) {
                    return undefined;
                }
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'number'.
                selectedIndex = null;
            }
            var value = selectedIndex !== null ? options[selectedIndex].value : null;
            _this.setState(function () { return ({
                selectedIndex: selectedIndex,
                value: value,
                searchText: "",
                options: options,
                displayedOptions: null
            }); });
            _this.toggleVisibility(typeof selectedIndex !== "number");
            return value;
        };
        return _this;
    }
    PINSelectInput.prototype.componentWillReceiveProps = function (props) {
        // Only reset options if new
        if (!isEqual_1.default(props.options, this.props.options)) {
            this.resetOptions(props);
            this.resetValue(props.value || this.state.value, props.options);
        }
        // If value has been reset by parent, reset it here too
        if (props.value !== this.props.value) {
            this.resetValue(props.value);
        }
    };
    PINSelectInput.prototype.componentDidMount = function () {
        /* Compute the initial index if one */
        var selectedIndex = null;
        var value = this.state.value;
        this.state.options.forEach(function (option, i) {
            if (option.value === value) {
                selectedIndex = i;
            }
        });
        if (selectedIndex === null) {
            value = null;
            if (!this.props.emptySelection && this.props.options) {
                this.onChange(null, { option: this.props.options[0], index: 0 });
                return;
            }
            this.setState(function () { return ({ selectedIndex: selectedIndex, value: value, searchText: "", displayedOptions: null }); });
        }
        else {
            this.setState(function () { return ({ selectedIndex: selectedIndex }); });
        }
        if (!this.props.onChangeForm) {
            return;
        }
        /* Inform the form of the input initial value and validity */
        var error = this.getError(value);
        if (this.props.showInitialError) {
            this.setState(function () { return ({ error: error }); });
        }
        this.props.onChangeForm(this.props.name, value, this.props.defaultValue, error);
    };
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINSelectInput' is not ... Remove this comment to see the full error message
    PINSelectInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, hiddenRequired = _a.hiddenRequired, name = _a.name, emptySelection = _a.emptySelection, isSearchable = _a.isSearchable, id = _a.id;
        var className = "pinselectinput " + (this.props.className || "");
        className += this.props.focused === true ? " focused" : "";
        var error = this.props.error || this.state.error;
        className += typeof error === "string" ? " error" : "";
        var _b = this.state, displayedOptions = _b.displayedOptions, options = _b.options, value = _b.value, selectedIndex = _b.selectedIndex, searchText = _b.searchText, isExpand = _b.isExpand;
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement("select", { className: "pinselectinput-hidden", name: name, id: (id || name), value: value, onChange: function (event) {
                    var index = options.findIndex(function (opt) { return (opt.value === event.target.value); });
                    _this.onChange(null, { option: options[index], index: index });
                } }, options.map(function (option, index) {
                var textLabel = _getSearchTextFor(option.label).trim();
                return (react_1.default.createElement("option", { key: "pinselectinput" + index + textLabel + option.value, value: option.value }, textLabel));
            })),
            this.props.label && (react_1.default.createElement("div", { className: "pinselectinput-label" },
                (required && !hiddenRequired) && "* ",
                this.props.label || "")),
            react_1.default.createElement("div", { className: "pinselectinput-current", onClick: this.onClickOnCurrent },
                (isSearchable && isExpand)
                    ? react_1.default.createElement("input", { value: searchText, onChange: this.onSearch, className: "pinselectinput-search", placeholder: this.props.searchPlaceholder || emptySelection || "", autoFocus: true })
                    : react_1.default.createElement("div", { className: "pinselectinput-current-text" }, selectedIndex !== null
                        ? options[selectedIndex].label : emptySelection),
                react_1.default.createElement(react_2.Icon, { icon: "mdi:menu-down", style: { fontSize: "1.8rem" } })),
            react_1.default.createElement("ul", { className: "pinselectinput-options-list " + (this.state.isExpand ? "visible" : ""), ref: function (node) { _this.node = node; } }, (displayedOptions || options).map(function (option, index) { return (react_1.default.createElement("li", { key: "pinselectinput-option" + index + option.label + option.value, className: "pinselectinput-option" + (option.value === value ? " selected" : ""), onClick: function () { return _this.onChange(null, {
                    option: option,
                    index: options.findIndex(function (opt) { return (opt.value === value); })
                }); } }, option.label)); })),
            (this.props.error || this.state.error)
                && react_1.default.createElement("div", { className: "pinselectinput-error" }, this.props.error)));
    };
    PINSelectInput.className = "PINSelectInput";
    PINSelectInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { options: prop_types_1.default.arrayOf(prop_types_1.default.shape(PINOption_1.PINOption.propTypes)), emptySelection: prop_types_1.default.string, focused: prop_types_1.default.bool, isSearchable: prop_types_1.default.bool });
    return PINSelectInput;
}(PINInput_1.PINInput));
exports.PINSelectInput = PINSelectInput;
//# sourceMappingURL=PINSelectInput.js.map